/** Shared layout/field classes for login, register, reset-password. */
export const authPageShellClass =
  'min-h-screen bg-gradient-to-br from-slate-100 via-white to-[var(--app-primary-soft)] p-4 text-slate-900 dark:bg-[var(--app-bg)] dark:from-[var(--app-bg)] dark:via-[var(--app-bg)] dark:to-[var(--app-surface-soft)] dark:text-[var(--app-text)]';

export const authCardClass =
  'rounded-[28px] border border-[var(--app-border)] bg-[var(--app-surface)] shadow-xl backdrop-blur';

export const authFieldClass =
  'h-11 w-full rounded-xl border border-[var(--app-border)] bg-[var(--app-input-bg)] px-3 text-base text-[var(--app-text)] outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:bg-[var(--app-input-bg-focus)]';

export const authLabelClass = 'mb-1 block text-sm font-medium text-[var(--app-text)]';

export const authMutedTextClass = 'text-[var(--app-text-soft)]';

export const authPanelClass =
  'rounded-2xl border border-[var(--app-border)] bg-[var(--app-surface-soft)] px-4 py-3';

export const authIconButtonClass =
  'absolute right-1.5 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-lg text-[var(--app-text-soft)] hover:bg-[var(--app-surface-soft)] hover:text-[var(--app-text)]';

export const authChoiceCardClass = (selected: boolean) =>
  `flex cursor-pointer flex-col rounded-2xl border px-3 py-2.5 text-sm transition ${
    selected
      ? 'border-primary-500 bg-[var(--app-primary-soft)] '
      : 'border-[var(--app-border)] bg-[var(--app-surface)] hover:bg-[var(--app-surface-soft)]'
  }`;
